import React from 'react'
import PropTypes from 'prop-types'
import makeStyles from '@mui/styles/makeStyles'

import SearchInput from '../../Common/SearchInput'
import DateFilterContacts from './DateFilterContacts'
import ColumnFilterContacts from './ColumnFilterContacts'
import Exporter from './Exporter'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
  },
  controlForm: {
    marginLeft: theme.spacing(2),
    width: 90,
  },
}))

const ControlsConfigurationContacts = (props) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <SearchInput
        value={props.searchText}
        onChange={props.onSearchTextChange}
        placeholder={'Email Address'}
        addMarginLeft={false}
      />
      <DateFilterContacts
        onFiltersAdd={props.onFiltersAdd}
      />
      <ColumnFilterContacts
        onFiltersAdd={props.onFiltersAdd}
      />
      <div style={{ flexGrow: 1 }} />
      <Exporter
        onExport={props.onExport}
        rowCount={props.rowCount}
      />
    </div>
  )
}

ControlsConfigurationContacts.propTypes = {
  filters: PropTypes.array.isRequired,
  onFiltersAdd: PropTypes.func.isRequired,
  onFilterDelete: PropTypes.func.isRequired,
  onFilterDeleteAll: PropTypes.func.isRequired,
  searchText: PropTypes.string,
  onSearchTextChange: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired,
  rowCount: PropTypes.number,
}

export default ControlsConfigurationContacts
